<template>
  <main class="antaras">
    <nav>
      <button class="nav-button" v-bind:class="{'is-active': navContent}" @click="navContent = !navContent;"><span class="nav-icon"></span></button>
      <transition name="fade">
        <div class="nav" v-show="navContent">
          <div class="nav-content">
            <ul class="nav-list">
              <li><a class="nav-link" href="#story" @click="navContent = !navContent;"><img src="@/assets/img/nav-antaras-story.png" loading="lazy" alt="ストーリー STORY"></a></li>
              <li><a class="nav-link" href="#character" @click="navContent = !navContent;"><img src="@/assets/img/nav-antaras-character.png" loading="lazy" alt="キャラクター CHARACTER"></a></li>
              <li><a class="nav-link" href="#system" @click="navContent = !navContent;"><img src="@/assets/img/nav-antaras-system.png" loading="lazy" alt="システム SYSTEM"></a></li>
            </ul>
            <div class="nav-banner">
              <router-link class="nav-link" to="/"><img src="@/assets/img/banner-4th.png" loading="lazy" alt="4周年記念情報 詳細を見る"></router-link>
            </div>
            <div class="nav-share">
              <img src="@/assets/img/nav-share.png" loading="lazy" alt="SHARE">
              <ul>
                <li><a href="//twitter.com/share?text=リネレボ4周年特設サイト。拡張パック〈アンタラスの憤怒〉実装や4周年記念生放送の情報、リネレボ名刺メーカーなど、リネレボ4周年を記念したイベント・キャンペーン情報をお届けします！&url=https://l2.netmarble.jp/event/4th-anniversary/antaras/&hashtags=リネレボ4周年" rel="noopener" onClick="window.open(encodeURI(decodeURI(this.href)), 'twitterWindow', 'width=650, height=470, personalbar=0, toolbar=0, scrollbars=1, sizable=1'); return false;"><img src="@/assets/img/nav-twitter.png" loading="lazy" alt="Twitter"></a></li>
                <li><a href="//www.facebook.com/share.php?u=https://l2.netmarble.jp/event/4th-anniversary/antaras/" rel="noopener" onClick="window.open(encodeURI(decodeURI(this.href)), 'facebookWindow', 'width=650, height=470, personalbar=0, toolbar=0, scrollbars=1, sizable=1'); return false;"><img src="@/assets/img/nav-facebook.png" loading="lazy" alt="Facebook"></a></li>
                <li><a href="http://line.me/R/msg/text/?%E3%83%AA%E3%83%8D%E3%83%AC%E3%83%9C4%E5%91%A8%E5%B9%B4%E7%89%B9%E8%A8%AD%E3%82%B5%E3%82%A4%E3%83%88%E3%80%82%E6%8B%A1%E5%BC%B5%E3%83%91%E3%83%83%E3%82%AF%E3%80%88%E3%82%A2%E3%83%B3%E3%82%BF%E3%83%A9%E3%82%B9%E3%81%AE%E6%86%A4%E6%80%92%E3%80%89%E5%AE%9F%E8%A3%85%E3%82%844%E5%91%A8%E5%B9%B4%E8%A8%98%E5%BF%B5%E7%94%9F%E6%94%BE%E9%80%81%E3%81%AE%E6%83%85%E5%A0%B1%E3%80%81%E3%83%AA%E3%83%8D%E3%83%AC%E3%83%9C%E5%90%8D%E5%88%BA%E3%83%A1%E3%83%BC%E3%82%AB%E3%83%BC%E3%81%AA%E3%81%A9%E3%80%81%E3%83%AA%E3%83%8D%E3%83%AC%E3%83%9C4%E5%91%A8%E5%B9%B4%E3%82%92%E8%A8%98%E5%BF%B5%E3%81%97%E3%81%9F%E3%82%A4%E3%83%99%E3%83%B3%E3%83%88%E3%83%BB%E3%82%AD%E3%83%A3%E3%83%B3%E3%83%9A%E3%83%BC%E3%83%B3%E6%83%85%E5%A0%B1%E3%82%92%E3%81%8A%E5%B1%8A%E3%81%91%E3%81%97%E3%81%BE%E3%81%99%EF%BC%81+https://l2.netmarble.jp/event/4th-anniversary/antaras/+%EF%BC%83%E3%83%AA%E3%83%8D%E3%83%AC%E3%83%9C4%E5%91%A8%E5%B9%B4" rel="noopener" onClick="window.open(encodeURI(decodeURI(this.href)), 'lineWindow', 'width=650, height=470, personalbar=0, toolbar=0, scrollbars=1, sizable=1'); return false;"><img src="@/assets/img/nav-line.png" loading="lazy" alt="LINE"></a></li>
              </ul>
            </div>
          </div>
          <div class="nav-overlay"></div>
        </div>
      </transition>
    </nav>
    <section class="hero">
      <h1><img class="hero-logo-4th" src="@/assets/img/logo-4th.png" loading="lazy" alt="4th Anniversary">
        <img class="hero-logo-antaras" src="@/assets/img/logo-antaras.png" loading="lazy" alt="アンタラスの怒り"></h1>
        <StoreBadge/>
      <div class="scroll">
        <span class="scroll-arrow"><span></span></span>
        <img src="@/assets/img/scroll.png" loading="lazy" alt="SCROLL">
      </div>
    </section>
    <section id="story" class="story">
      <h2 class="story-title"><img src="@/assets/img/story-title.png" loading="lazy" alt="ストーリー STORY"></h2>
      <div class="story-img">
        <picture>
          <source media="(min-width: 829px)" srcset="@/assets/img/story-character-pc.png">
          <img src="@/assets/img/story-character-sp.png" loading="lazy" alt="">
        </picture>
      </div>
      <p>シーレンの子である六匹の竜の一匹、アンタラスは<br>
      神々との戦争で敗北して古龍山脈に身を隠し、<br>
      深い眠りに落ちる。</p>
      <p>時が流れ、アンタラスが眠る古龍山脈の近くに<br>
      ドワーフたちが拠点を建てるようになり、<br>
      次第に大きく鳴り響く採掘の音で<br>
      アンタラスが目を覚ます。</p>
      <p>激怒したアンタラスは、<br>
      ドワーフたちの城を攻撃することになる…</p>
    </section>
    <section id="character" class="character">
      <h2 class="character-title"><img src="@/assets/img/character-title.png" loading="lazy" alt="キャラクター CHARACTER"></h2>
      <p>アデン大陸の古の英雄たち</p>
      <VueSlickCarousel v-bind="settings">
        <div class="characterCard" v-bind:class="{isActive:isActive01}">
          <div class="characterCard-side front">
            <img class="characterCard-character" src="@/assets/img/character-human.png" loading="lazy" alt="ハンド・ヴァン・ホルター">
            <div class="characterCard-text-front">
              <span class="race">human</span><br>
              <span class="name">ハンド･ヴァン･ホルター</span><br>
              装備 &nbsp; &nbsp;片手剣/ウォリアー
            </div>
            <button class="characterCard-button" v-on:click="isActive01=!isActive01"><img src="@/assets/img/character-button-open.png" loading="lazy" alt="open"></button>
          </div>
          <div class="characterCard-side back">
            <div class="characterCard-text-back">
              <span class="position">エルモアデン連合軍の総司令官</span>
              <span class="name">ハンド･ヴァン･ホルター</span>
              <p>シュナイマン皇帝がエルモアデンを統一した時、彼のそばで最も大きい功績を挙げた騎士団長。</p>
              <p>シュナイマン皇帝とは幼い頃から友人だったため、ハンド・ヴァン・ホルターへの皇帝の信頼は強かった。</p>
              <p>アンタラスが現れた時、皇帝はエルモアデン連合軍の総司令官に彼を任命し、アンタラス討伐の功績によりヴァン・ホルター家はエルモアの地域を治める貴族となった。</p>
            </div>
            <button class="characterCard-button" v-on:click="isActive01=!isActive01"><img src="@/assets/img/character-button-close.png" loading="lazy" alt="open"></button>
          </div>
        </div>
        <div class="characterCard" v-bind:class="{isActive:isActive02}">
          <div class="characterCard-side front">
            <img class="characterCard-character" src="@/assets/img/character-elf.png" loading="lazy" alt="セリス・ウィンドウォーカー">
            <div class="characterCard-text-front">
              <span class="race">elf</span><br>
              <span class="name">セリス･ウィンドウォーカー</span><br>
              装備 &nbsp; &nbsp;杖/メイジ
            </div>
            <button class="characterCard-button" v-on:click="isActive02=!isActive02"><img src="@/assets/img/character-button-open.png" loading="lazy" alt="open"></button>
          </div>
          <div class="characterCard-side back">
            <div class="characterCard-text-back">
              <span class="position">エルフの女王</span>
              <span class="name">セリス･ウィンドウォーカー</span>
              <p>エルフの王だった父が人間の裏切りによって亡くなった後、彼の長女であるセリスがエルフの女王に擁立された。</p>
              <p>彼女を女王に擁立した多くのエルフたちは、彼女が父の復讐のために、そしてエルフのために人間と敵対することを期待したが、期待とは裏腹に彼女は平和政策を打ち出した。</p>
              <p>エルフたちは彼女の政策に反対したが、女王の発言は絶対的だったため、不満を口にすることはできなかった。</p>
              <p>そんな中、エルモアデンよりシュナイマン皇帝からの招集があった。人間との対話の機会だと考えたセリスは、エルモアデンに向かった。</p>
            </div>
            <button class="characterCard-button" v-on:click="isActive02=!isActive02"><img src="@/assets/img/character-button-close.png" loading="lazy" alt="open"></button>
          </div>
        </div>
        <div class="characterCard" v-bind:class="{isActive:isActive03}">
          <div class="characterCard-side front">
            <img class="characterCard-character" src="@/assets/img/character-darkelf.png" loading="lazy" alt="ハルケン・ハイツ">
            <div class="characterCard-text-front">
              <span class="race">dark elf</span><br>
              <span class="name">ハルケン･ハイツ</span><br>
              装備 &nbsp; &nbsp;弓/ローグ
            </div>
            <button class="characterCard-button" v-on:click="isActive03=!isActive03"><img src="@/assets/img/character-button-open.png" loading="lazy" alt="open"></button>
          </div>
          <div class="characterCard-side back">
            <div class="characterCard-text-back">
              <span class="position">一族の裏切り者</span>
              <span class="name">ハルケン･ハイツ</span>
              <p>人間の裏切りにより、家族を失ったエルフ。彼はエルフの森の警備隊長を務めていたが、心の中では常に人間への復讐心を燃やしていた。</p>
              <p>そんな中、エルフの森でダスパリオンに出会い、黒魔法を利用した悪魔の力を授けられる。</p>
              <p>しかし悪魔の力が暴走したせいで、彼は自分の部下と他のエルフたちをも殺めてしまった。黒魔法の力により姿までも灰色に染まり、ダークエルフとなってしまった彼は、一族の裏切り者となって森を去り、ダスパリオンを探し回るようになった。</p>
            </div>
            <button class="characterCard-button" v-on:click="isActive03=!isActive03"><img src="@/assets/img/character-button-close.png" loading="lazy" alt="open"></button>
          </div>
        </div>
        <div class="characterCard" v-bind:class="{isActive:isActive04}">
          <div class="characterCard-side front">
            <img class="characterCard-character" src="@/assets/img/character-dwarf.png" loading="lazy" alt="マフネル">
            <div class="characterCard-text-front">
              <span class="race">dwarf</span><br>
              <span class="name">マフネル</span><br>
              装備 &nbsp; &nbsp;槍/ウォリアー
            </div>
            <button class="characterCard-button" v-on:click="isActive04=!isActive04"><img src="@/assets/img/character-button-open.png" loading="lazy" alt="open"></button>
          </div>
          <div class="characterCard-side back">
            <div class="characterCard-text-back">
              <span class="position">貴族家の令嬢</span>
              <span class="name">マフネル</span>
              <p>ドワーフ貴族の令嬢であるマフネルは、ドワーフたちが山に姿を隠した時、家を離れアデン大陸を旅していた。</p>
              <p>しかし彼女は旅の途中、彼女の両親がアンタラスを起こして、その結果古龍山脈の周辺が壊滅したという噂を聞いた。</p>
              <p>彼女は他のドワーフたちに助けを求めたが、打算的な性格のドワーフたちは、誰も災いのようなアンタラスを相手にしようとせず、「マフネルの両親が無理な採掘で眠っていたアンタラスを起こしたせいで災いを招いた」と彼女を非難した。</p>
              <p>彼女はアンタラスを眠らせるために、そして両親の名誉を取り戻すためにエルモアデンの皇帝、シュナイマンを訪ねた。</p>
            </div>
            <button class="characterCard-button" v-on:click="isActive04=!isActive04"><img src="@/assets/img/character-button-close.png" loading="lazy" alt="open"></button>
          </div>
        </div>
      </VueSlickCarousel>
    </section>
    <section id="system" class="system">
      <h2 class="system-title"><img src="@/assets/img/system-title.png" loading="lazy" alt="システム SYSTEM"></h2>
      <div class="system-wrap">
        <div class="system-training">
          <h3><img src="@/assets/img/system-training-title.png" loading="lazy" alt="育成"></h3>
          <div class="system-box">
            <img src="@/assets/img/system-training-img.png" loading="lazy" alt="育成">
            <p class="sub">既存のキャラクターも成長できる</p>
            <p class="title">様々な育成要素</p>
            <p><strong>既存のキャラクター育成とは異なる<br>
            新しい育成システムを体験してください！</strong></p>
            <p>キャラクターをより簡単に成長させることができます。<br>
            また拡張パックのキャラクターを育成すると、既存のキャラクターも強くなれます。</p>
          </div>
        </div>
        <div class="system-dungeon">
          <h3><img src="@/assets/img/system-dungeon-title.png" loading="lazy" alt="ダンジョン"></h3>
          <div class="system-box">
            <img src="@/assets/img/system-dungeon-img.jpg" loading="lazy" alt="ダンジョン">
            <p class="sub">多様なテーマで楽しめる</p>
            <p class="title">ダンジョンコンテンツ</p>
            <p><strong>拡張パック専用次元の迷路<br>
            拡張パック専用エリートダンジョン<br>
            拡張パック専用放置型フィールド<br>
            拡張パック専用侵攻ダンジョン</strong></p>
            <p>拡張パックが追加される度、新しいコンセプトとテーマを持つダンジョンが追加されます。<br>
            新しく登場する放置型フィールドと侵攻ダンジョンもお楽しみに！</p>
          </div>
        </div>
        <div class="system-pvp">
          <h3><img src="@/assets/img/system-pvp-title.png" loading="lazy" alt="PvP"></h3>
          <div class="system-box">
            <img src="@/assets/img/system-pvp-img.jpg" loading="lazy" alt="PvP">
            <p class="sub">成長の格差なく楽しめる</p>
            <p class="title">PvPコンテンツ</p>
            <p>既にプレイしているユーザーとは成長格差があるため、新しく始めても難しい…と考えている方へ。</p>
            <p><strong>新しい拡張パックが始まると、全てのユーザーが同等となるPvPコンテンツをお楽しみいただけます！</strong></p>
            <p>拡張パックのキャラクター同士が戦うPvPでは、既存のキャラクターとは違った楽しみ方ができます。誰でも、今始めても、最強を目指すことも可能です！</p>
          </div>
        </div>
        <div class="system-boss">
          <h3><img src="@/assets/img/system-boss-title.png" loading="lazy" alt="レイドボス"></h3>
          <div class="system-box">
            <img src="@/assets/img/system-boss-img.jpg" loading="lazy" alt="レイドボス">
            <p class="sub">初のドラゴンレイドボス</p>
            <p class="title">アンタラス</p>
            <p><strong>レイドボスは、最大25人で攻撃隊を作って挑戦が可能です。</strong></p>
            <p>攻撃隊を形成し、アンタラスの脅威に立ち向かって奪われた城の奪還に挑戦しましょう！</p>
          </div>
        </div>
      </div>
    </section>
    <section class="info">
      <div class="info-banner">
        <router-link to="/"><img src="@/assets/img/banner-4th.png" loading="lazy" alt="4周年記念情報 詳細を見る"></router-link>
      </div>
      <ul class="info-official">
        <li><a href="//l2.netmarble.jp" rel="noopener"><img src="@/assets/img/banner-official.png" loading="lazy" alt="公式サイト"></a></li>
        <li><a href="//forum.netmarble.com/lin2jp" rel="noopener"><img src="@/assets/img/banner-forum.png" loading="lazy" alt="公式フォーラム"></a></li>
      </ul>
    </section>
  </main>
</template>

<style lang="scss">
.antaras {
  background: #000 url('~@/assets/img/background-sp.jpg') no-repeat 50% 0 / cover;
  @media (min-width: 829px) {
    background: #000 url('~@/assets/img/background-pc.jpg') no-repeat 0 0 / 192rem auto;
    padding-bottom: 12rem;
  }
}

/* nav */

.antaras {
  .nav-list li {
    border: 0;
    a {
      @media (min-width: 829px) {
        display: block;
        width: 33rem;
      }
    }
    ~ li {
      margin-top: 7.8rem;
      @media (min-width: 829px) {
        margin-top: 4.7rem;
      }
    }
  }
  .nav-banner {
    margin-top: 10.5rem;
    @media (min-width: 829px) {
      margin-top: 8.6rem;
    }
  }
}

/* hero */

.antaras .hero {
  height: 139.8rem;
  position: relative;
  @media (min-width: 829px) {
    height: 97rem;
  }
}

.antaras .hero-logo-4th {
  left: calc(50% - 30.6rem);
  top: 30rem;
  width: 59.2rem;
  @media (min-width: 829px) {
    left: calc(50% - 23.2rem);
    top: 13.1rem;
    width: 47.3rem;
  }
}

.hero-logo-antaras {
  left: calc(50% - 39.7rem);
  position: absolute;
  top: 74.5rem;
  width: 72.6rem;
  @media (min-width: 829px) {
    left: calc(50% - 30.5rem);
    top: 48.7rem;
    width: 58.1rem;
  }
}

/* scroll */

.scroll {
  bottom: 9.9rem;
  left: 0;
  margin: 0 auto;
  position: absolute;
  right: 0;
  width: 7.3rem;
  z-index: 2;
  @media (min-width: 829px) {
    bottom: 7.9rem;
    width: 4.5rem;
  }
}

.scroll-arrow {
  bottom: 2.3rem;
  height: 10rem;
  left: 0;
  margin: auto;
  overflow: hidden;
  position: absolute;
  right: 0;
  @media (min-width: 829px) {
    bottom: 17.5%;
    height: 8rem;
  }
  span {
    animation: scrollDown 1.5s infinite;
    bottom: 3.2rem;
    left: 0;
    margin: auto;
    position: absolute;
    right: 0;
    @media (min-width: 829px) {
      bottom: 4rem;
    }
    &::before,
    &::after {
      bottom: 0;
      content: '';
      display: block;
      margin: auto;
      position: absolute;
      right: 0;
    }
    &::before {
      background: #fff;
      height: 10rem;
      left: -.5px;
      width: 1px;
    }
    &::after {
      border-left: 1px solid #fff;
      border-bottom: 1px solid #fff;
      height: 1.9rem;
      left: 0;
      transform: rotate(-45deg);
      width: 1.9rem;
      @media (min-width: 829px) {
        height: 1.1rem;
        width: 1.1rem;
      }
    }
  }
}

@keyframes scrollDown {
  0% {
    transform: translate(0, 0);
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    transform: translate(0, 2rem);
    opacity: 0;
  }
}

/* story */

.story {
  position: relative;
}

.story-title {
  margin: 0 auto;
  width: 37.8rem;
  @media (min-width: 829px) {
    width: 30.5rem;
  }
}

.story-img {
  background: url('~@/assets/img/story-character-background-sp.jpg') no-repeat 0 0 / 100% 100%;
  margin-top: 12.5rem;
  padding-top: 77.295%;
  position: relative;
  width: 94.686%;
  @media (min-width: 829px) {
    background: url('~@/assets/img/story-character-background-pc.jpg') no-repeat 100% 0 / auto 100%;
    height: 46rem;
    left: auto;
    margin: 0;
    padding: 0;
    position: absolute;
    right: calc(50% - 13.1rem);
    top: 20.3rem;
    width: 109.1rem;
  }
  img {
    bottom: 0;
    left: 0;
    position: absolute;
    @media (min-width: 829px) {
      bottom: 0;
      left: auto;
      right: 2.3rem;
      width: 81.5rem;
    }
  }
  ~ p {
    margin-top: 1.7em;
    text-align: center;
    @media (min-width: 829px) {
      line-height: 2;
      margin-left: calc(50% + 15.6rem);
      text-align: left;
    }
  }
  + p {
    margin-top: 6.8rem;
    @media (min-width: 829px) {
      margin-top: 8.3rem;
    }
  }
}

/* character */

.character-title {
  margin: 20.1rem auto 0;
  width: 72.1rem;
  @media (min-width: 829px) {
    margin-top: 29.2rem;
    width: 57.9rem;
  }
  + p {
    margin-top: 2.6rem;
    text-align: center;
    @media (min-width: 829px) {
      margin-top: 2.2rem;
    }
  }
}

.slick-slider {
  margin-top: 6.1rem;
  @media (min-width: 829px) {
    margin-top: 7rem;
  }
}

.slick-list {
  overflow: visible !important;
}

.slick-slide {
  position: relative;
}

.slick-dots li {
  height: 1.8rem;
  margin: 0;
  transition: .5s all;
  width: 1.8rem;
  @media (min-width: 829px) {
    height: 1.2rem;
    width: 1.2rem;
  }
  button:before {
    background: #7e4ad5;
    border-radius: 50%;
    color: transparent;
    height: 100%;
    opacity: .56;
    overflow: hidden;
    transition: .5s all;
    width: 100%;
  }
  &.slick-active {
    width: 4.8rem;
    @media (min-width: 829px) {
      width: 3.3rem;
    }
    button:before {
      border-radius: .9rem;
      color: #7e4ad5;
    }
  }
  ~ li {
    margin-left: 3.5rem;
  }
}

.characterCard-side {
  backface-visibility: hidden;
  background: url('~@/assets/img/character-box-front.png') no-repeat 0 0 / 100% 100%;
  color: #fff;
  height: 92.6rem;
  position: relative;
  transition: all .5s;
  width: 68rem !important;
  @media (min-width: 829px) {
    height: 62.6rem;
    width: 41rem !important;
  }
  &.back {
    background: url('~@/assets/img/character-box-back.png') no-repeat 0 0 / 100% 100%;
    left: 0;
    position: absolute;
    top: 0;
    transform: rotateY(180deg);
  }
  .isActive & {
    &.front {
      transform: rotateY(180deg);
    }
    &.back {
      transform: rotateY(0);
    }
  }
}

.characterCard-character {
  bottom: 1.188%;
  left: 4.559%;
  position: absolute;
  width: 91.471%;
}

.characterCard-text-front {
  bottom: 7.343%;
  left: 12.5%;
  position: absolute;
  .race {
    opacity: .5;
  }
  .name {
    display: inline-block;
    font-size: 4.2rem;
    font-weight: 700;
    margin: .9rem 0 3.8rem;
    @media (min-width: 829px) {
      font-size: 2.531rem;
      margin: .6rem 0 2.2rem;
    }
  }
}

.characterCard-text-back {
  padding: 9.1rem 10% 0;
  @media (min-width: 829px) {
    padding-top: 5.7rem;
  }
  .position {
    display: block;
    font-size: 2.4rem;
    @media (min-width: 829px) {
      font-size: 1.4rem;
    }
  }
  .name {
    display: inline-block;
    font-size: 4.2rem;
    font-weight: 700;
    margin: 2.3rem 0 3.5rem;
    @media (min-width: 829px) {
      font-size: 2.531rem;
      margin: 1.4rem 0 2rem;
    }
  }
  p {
    color: #bdc4cb;
    font-size: 2.7rem;
    opacity: .8;
    @media (min-width: 829px) {
      font-size: 1.6rem;
    }
    ~ p {
      margin-top: .6em;
    }
  }
}

.characterCard-button {
  background: transparent;
  bottom: -.54%;
  cursor: pointer;
  position: absolute;
  right: 1.324%;
  width: 9.5rem;
  @media (min-width: 829px) {
    width: 5.8rem;
  }
}

/* system */

.system-title {
  margin: 30.3rem auto 0;
  width: 44rem;
  @media (min-width: 829px) {
    margin-top: 20.4rem;
    width: 35.5rem;
  }
}

.system-wrap {
  @media (min-width: 829px) {
    flex-wrap: wrap;
    display: flex;
    justify-content: space-between;
    margin: 7.1rem auto 0;
    width: 95rem;
  }
}

.system-box {
  background: url('~@/assets/img/system-box-background.jpg') no-repeat 0 0 / 100% auto;
  border: 1px solid #8a72bb;
  box-shadow: 0 1.1rem 1.3rem rgba(0, 0, 0, .48);
  margin: 2.1rem auto 0;
  padding-bottom: 4.4rem;
  position: relative;
  width: 72.4rem;
  @media (min-width: 829px) {
    background-size: auto 100%;
    height: 64rem;
    padding-bottom: 0;
    width: 44.9rem;
  }
  &::before,
  &::after {
    content: '';
    display: block;
    left: calc(-2rem - 1px);
    position: absolute;
    width: 76.5rem;
    @media (min-width: 829px) {
      left: calc(-1.2rem - 1px);
      width: 47.4rem;
    }
  }
  &::before {
    background: url('~@/assets/img/system-box-frame-top.png') no-repeat 0 0 / 100% auto;
    height: calc(100% - 1.5rem);
    top: calc(-.9rem - 1px);
    @media (min-width: 829px) {
      background-size: 100% 100%;
      height: calc(100% - 1rem);
      top: calc(-.6rem - 1px);
    }
  }
  &::after {
    background: url('~@/assets/img/system-box-frame-bottom.png') no-repeat 0 0 / 100% 100%;
    bottom: -3.4rem;
    height: 6rem;
    @media (min-width: 829px) {
      background-size: 100% 100%;
      bottom: -2.1rem;
      height: 3.8rem;
    }
  }
  > * {
    position: relative;
  }
  img {
    margin: 2.1rem auto 0;
    width: 68rem;
    @media (min-width: 829px) {
      margin-top: 1.4rem;
      width: 42.1rem;
    }
  }
  p {
    margin: 0 4.7rem;
    @media (min-width: 829px) {
      margin: 0 1.9rem;
    }
    &.sub {
      color: #b29e90;
      margin-top: 3.4rem;
      @media (min-width: 829px) {
        margin-top: 2.6rem;
      }
    }
    &.title {
      font-size: 4.2rem;
      font-weight: 700;
      margin-top: -.4rem;
      @media (min-width: 829px) {
        font-size: 3rem;
        margin-top: .2rem;
      }
      + p {
        margin-top: 1.7rem;
        @media (min-width: 829px) {
          margin-top: 1.8rem;
        }
      }
    }
    ~ p {
      margin-top: 2.1rem;
      @media (min-width: 829px) {
        margin-top: 1.3rem;
      }
    }
  }
}

.system-training {
  margin-top: 9.2rem;
  @media (min-width: 829px) {
    margin-top: 0;
  }
  h3 {
    margin: 0 auto;
    width: 20.4rem;
    @media (min-width: 829px) {
      width: 12.8rem;
    }
  }
  .system-box img {
    margin-top: -2.5rem;
    @media (min-width: 829px) {
      margin-top: -1.5rem;
    }
  }
  ~ div {
    margin-top: 10.8rem;
    @media (min-width: 829px) {
      margin-top: 0;
    }
  }
}

.system-dungeon {
  @media (min-width: 829px) {
    padding-top: 5rem;
    order: 2;
  }
  h3 {
    margin: 0 auto;
    width: 30.4rem;
    @media (min-width: 829px) {
      width: 20.8rem;
    }
  }
}

.system-pvp {
  @media (min-width: 829px) {
    order: 1;
  }
  h3 {
    margin: 0 auto;
    width: 20.4rem;
    @media (min-width: 829px) {
      margin-top: .6rem;
      width: 12.8rem;
    }
  }
  .system-box {
    @media (min-width: 829px) {
      margin-top: 2.4rem;
    }
  }}

.system-boss {
  @media (min-width: 829px) {
    padding-top: 5rem;
    order: 3;
  }
  h3 {
    margin: 0 auto;
    width: 30.4rem;
    @media (min-width: 829px) {
      width: 20.8rem;
    }
  }
}

/* info */

.antaras .info {
  padding-top: 48.7rem;
  @media (min-width: 829px) {
    padding-top: 13.4rem;
  }
}

.info-banner {
  margin: 0 auto;
  width: 62rem;
  @media (min-width: 829px) {
    width: 49.6rem;
  }
}

.info-official {
  display: flex;
  justify-content: center;
  li {
    margin-top: 6rem;
    width: 29.5rem;
    @media (min-width: 829px) {
      margin-top: 4.7rem;
      width: 23.6rem;
    }
    ~ li {
      margin-left: 4.5rem;
      @media (min-width: 829px) {
        margin-left: 3.6rem;
      }
    }
  }
}
</style>

<script>
import StoreBadge from '@/components/StoreBadge.vue'
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default {
  name: 'app',
  components: {
    StoreBadge,
    VueSlickCarousel
  },
  data() {
    return {
      navContent: false,
      settings: {
        infinite: false,
        dots: true,
        responsive: [
          {
            breakpoint: 2000,
            settings: {
              slidesToShow: 4,
              centerMode: true,
              centerPadding: '5%'
            }
          }, {
            breakpoint: 1700,
            settings: {
              slidesToShow: 3
            }
          }, {
            breakpoint: 829,
            settings: {
              slidesToShow: 1,
              centerMode: true,
              centerPadding: '8%'
            }
          }
        ]
      },
      isActive01: false,
      isActive02: false,
      isActive03: false,
      isActive04: false
    }
  },
  mounted() {
    $('.nav-button, .nav-link').on('click', function () {
      if ($('body').hasClass('is-fixed')) {
      	$('body').removeClass('is-fixed');
      } else {
        $('body').addClass('is-fixed');
      }
    })
  }
}
</script>
